import { render, staticRenderFns } from "./saasRateTemplate.vue?vue&type=template&id=324d7468&scoped=true&"
import script from "./saasRateTemplate.vue?vue&type=script&lang=js&"
export * from "./saasRateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./saasRateTemplate.vue?vue&type=style&index=0&id=324d7468&scoped=true&lang=scss&"
import style1 from "./saasRateTemplate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d7468",
  null
  
)

export default component.exports